export class TemplateNameMapper {
  private static readonly templateNameMappings: Record<string, string> = {
    // BFLUENCE
    ATUALIZACOES_CAMPANHA_BFLUENCE: 'bfluence_campanhas_atualizacoes',
    BENEFICIO_BFLUENCE: 'bfluence_comunidades_glambeneficioinativo',
    CAMPANHA_FINALIZADA_BFLUENCE: 'bfluence_campanhas_finalizada',
    CONTEUDO_APROVADO_BFLUENCE: 'bfluence_campanhas_conteudoaprovado',
    CONTEUDO_OU_METRICA_REPROVADOS_BFLUENCE:
      'bfluence_campanhas_conteudoreprovado',
    CONTEUDO_RECEBIDO_BFLUENCE: 'bfluence_campanhas_conteudoenviado',
    EX_COLABORADOR_BFLUENCE: 'bfluence_ex_colaborador',
    DOWNGRADE_BFLUENCE: 'bfluence_niveis_downgrade',
    DUPLICATED_BFLUENCE: 'bfluence_inscrição_antigo',
    FORGOT_PASSWORD_BFLUENCE: 'bfluence_login_redefinirsenha',
    INATIVIDADE_BFLUENCE: 'bfluence_inatividade',
    INCRICAO_EM_ANALISE_BFLUENCE: 'bfluence_campanhas_inscricaoenviada',
    INSCRICAO_APROVADA_BFLUENCE: 'bfluence_campanhas_inscricaoaprovada',
    INSCRICAO_REPROVADA_BFLUENCE: 'bfluence_campanhas_inscricao_reprovada',
    INVALID_DATA_BFLUENCE: 'bfluence_inscrição_dadosinvalidos',
    NOT_APPROVED_BFLUENCE: 'bfluence_inscrição_reprovado',
    NOVA_CAMPANHA_BFLUENCE: 'bfluence_campanhas_novapubli',
    PF_DADOS_INCORRETOS_BFLUENCE: 'bfluence_pagamento_PFerro',
    PF_COM_NF_MAS_SALDO_INSUFICIENTE_BFLUENCE: 'bfluence_pagamento_PFsemSaldo',
    PJ_COM_DUAS_NFS_UMA_PAGA_BFLUENCE: 'bfluence_pagamento_PJduasNF',
    PJ_COM_ERRO_NA_NF_OU_EM_DADOS_BFLUENCE: 'bfluence_pagamento_PJerro',
    PJ_SEM_NF_COM_SALDO_BFLUENCE: 'bfluence_pagamento_PJsemNF',
    QUEBRA_DE_REGRA_BFLUENCE: 'bfluence_saida_expulsao',
    RENOVACAO_BFLUENCE: 'bfluence_niveis_manteve',
    SAIDA_VOLUNTARIA_BFLUENCE: 'bfluence_saida_voluntaria',
    UPGRADE_BFLUENCE: 'bfluence_niveis_upgrade',

    // MENS
    ASSINATURA_CANCELADA_MENS: 'mens_assinatura_cancelada',
    ATUALIZACAO_CARTAO_MENS: 'mens_atualizacao_cartao',
    ATUALIZACAO_ENDERECO_MENS: 'mens_atualizacao_endereco',
    ATUALIZACAO_PHONE_MENS: 'mens_atualizacao_telefone',
    CAIXA_AVULSA_MENSMARKET: 'mens_caixa_avulsa',
    FORGOT_PASSWORD_MENSMARKET: 'mens_esqueceu_senha',
    ONBOARDING_MENSMARKET_PRIME: 'mens_onboarding_prime',
    ONBOARDING_MENSMARKET_SELECT: 'mens_onboarding_select',
    ORDER_BOLETO_MENS_LOJA: 'mens_pedido_boleto_loja',
    ORDER_CANCELED_MENS_LOJA: 'mens_pedido_cancelado_loja',
    ORDER_CONFIRMATION_MENS_LOJA: 'mens_pedido_confirmado_loja',
    ORDER_PIX_MENS_LOJA: 'mens_pedido_pix_loja',
    ORDER_STATUS_MENS_LOJA: 'mens_pedido_status_loja',

    // GLAM
    ALERTA_ESTOQUE_PRODUTO: 'glam_alerta_estoque_produto',
    ATUALIZACAO_CARTAO: 'glam_atualizacao_cartao',
    ATUALIZACAO_DADOS_PESSOAIS: 'glam_atualizacao_dados_pessoais',
    ATUALIZACAO_ENDERECO: 'glam_atualização_endereco',
    AVISO_AGUARDANDO_RETIRADA: 'glam_aviso_aguardando_retirada',
    AVISO_FALHA_ENTREGA: 'glam_aviso_falha_entrega',
    AVISO_RECORRENCIA: 'glam_aviso_recorrencia',
    FALHA_DE_PAGAMENTO_01: 'glam_falha_pagamento_saldo_insuficiente',
    FALHA_DE_PAGAMENTO_02: 'glam_falha_pagamento_erro_dados_cartao',
    FALHA_DE_PAGAMENTO_03: 'glam_falha_pagamento_outros_erros',
    FORGOT_PASSWORD: 'glam_esqueceu_senha',
    ORDER_CANCELED_LOJA: 'glam_pedido_cancelado_loja',
    ORDER_CONFIRMATION_LOJA: 'glam_pedido_confirmado_loja',
    ORDER_PIX_LOJA: 'glam_peido_pix_loja',
    ORDER_BOLETO_LOJA: 'glam_pedido_boleto_loja',
    ORDER_STATUS_LOJA: 'glam_pedido_status_loja',
    ORDER_STATUS_CANCELADO_LOJA: 'glam_pedido_status_cancelado_loja',
    STATUS_CLUBE_01: 'glam_status_clube_confirmado',
    STATUS_CLUBE_02: 'glam_status_clube_separacao',
    STATUS_CLUBE_03: 'glam_status_clube_aguardando_envio',
    STATUS_CLUBE_04: 'glam_status_clube_em_transporte',
    STATUS_CLUBE_05: 'glam_status_clube_entregue',
    SUBSCRIPTION_CONFIRMATION: 'glam_assinatura_confirmada',
    SUBSCRIPTION_CONFIRMATION_RENEWAL_MONTHLY:
      'glam_assinatura_renovacao_confirmada',
    TROCA_JOIA_DIAMANTE_VERMELHO: 'glam_troca_joia_diamante_vermelho',
    TROCA_JOIA_OUTROS: 'glam_troca_joia_outras',
    TROCA_PLANO_AGENDAMENTO: 'glam_troca_plano_agendada',
    TROCA_PLANO_PAGAMENTO: 'glam_troca_plano_pagamento',
    VALIDA_USUARIO: 'glam_validacao_usuario'
  };

  static mapTemplateName(originalTemplateName: string): string {
    if (!originalTemplateName) {
      return originalTemplateName;
    }

    const mappedName = this.templateNameMappings[originalTemplateName];
    return mappedName || originalTemplateName;
  }

  static mapTemplateNames<T extends { templateName?: string }>(
    templates: T[]
  ): T[] {
    if (!templates) {
      return templates;
    }

    return templates.map((template) => ({
      ...template,
      templateName: this.mapTemplateName(template.templateName)
    }));
  }
}
